import { OctokitResponse } from "@octokit/types";

type OctokitFunction<T, R> = (params: T) => Promise<OctokitResponse<R>>;

// TODO(polish): Clear this sometimes!
const _CACHE: Record<string, Record<string, string>> = {};

function checkCache(name: string, key: string) {
  if (!_CACHE[name]) {
    _CACHE[name] = {};
  }

  const cachedVal = _CACHE[name][key];
  if (cachedVal) {
    return JSON.parse(cachedVal);
  }

  return undefined;
}

function setCache(name: string, key: string, data: any) {
  if (!_CACHE[name]) {
    _CACHE[name] = {};
  }

  _CACHE[name][key] = JSON.stringify(data);
}

export async function call<T, R>(
  name: string,
  fn: OctokitFunction<T, R>,
  args: T
): Promise<R> {
  const argsKey = JSON.stringify(args);

  const cachedVal = checkCache(name, argsKey);
  if (cachedVal) {
    console.log(`Cache hit for ${name} with ${argsKey}`);
    return cachedVal as R;
  }

  const res = await fn(args);
  const data = res.data;

  setCache(name, argsKey, data);
  return data;
}

export async function callGql(
  name: string,
  query: string,
  fn: (arg: string) => unknown
) {
  const cachedVal = checkCache(name, query);
  if (cachedVal) {
    console.log(`Cache hit for ${name}`);
    return cachedVal;
  }

  const res = await fn(query);

  setCache(name, query, res);
  return res;
}
